export enum TimeSheetBreakType {
  Meal = 'Meal',
  Rest = 'Rest',
  Both = 'Both',
}